export default __webpack_public_path__ + "static/media/background_footer.fdad54df.png";